function hasDesktopStore() {
  return typeof window !== "undefined" && Boolean(window.desktopStore);
}

export async function getDesktopValue(key, fallbackValue = null) {
  try {
    if (hasDesktopStore()) {
      const value = await window.desktopStore.get(key);
      return value ?? fallbackValue;
    }
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallbackValue;
  } catch (_error) {
    return fallbackValue;
  }
}

export async function setDesktopValue(key, value) {
  try {
    if (hasDesktopStore()) {
      await window.desktopStore.set(key, value);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_error) {
    // no-op
  }
}

export async function removeDesktopValue(key) {
  try {
    if (hasDesktopStore()) {
      await window.desktopStore.remove(key);
      return;
    }
    localStorage.removeItem(key);
  } catch (_error) {
    // no-op
  }
}
